import { LocalType } from "../../models/localType";
import CategorySingleFilter from "./CategorySingleFilter";
import React from "react";

type CategoryFiltersProps = {
    lang: keyof LocalType;
    categories: any[];
    categoryFilter: any;
    setCategoryFilter: any;
    search: string;
    setSearch: (search: string) => void;
    template: any;
};

export default function CategoryFilters(props: CategoryFiltersProps) {
    const { lang, categories, categoryFilter, setCategoryFilter, template } = props;

    const categoryTypes = {
        simple: {
            fr_CA: "Tuyau noir simple paroi",
            en_CA: "Single Wall Stove Pipe",
            en_US: "Single Wall Stove Pipe",
        },
        double: {
            fr_CA: "Tuyau noir double paroi",
            en_CA: "Double Wall Stove Pipe",
            en_US: "Double Wall Stove Pipe",
        },
        flexliner: {
            fr_CA: "Gaine flexible",
            en_CA: "Stainless flex liner",
            en_US: "Stainless flex liner",
        },
    };

    const simple = categories.filter((cat) => cat.type === categoryTypes.simple[lang]);
    const double = categories.filter((cat) => cat.type === categoryTypes.double[lang]);
    const flexliner = categories.filter(
        (cat) => cat.type !== categoryTypes.simple[lang] && cat.type !== categoryTypes.double[lang]
    );

    return (
        <div className="filters">
            <div className="categories">
                {template === "Venting" ? (
                    <>
                        <h4 className="filterName">{categoryTypes.simple[lang]}</h4>
                        {simple
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((category, index) => {
                                return (
                                    <CategorySingleFilter
                                        key={`cat-single-${category.id}-${index}`}
                                        category={category}
                                        index={index}
                                        categoryFilter={categoryFilter}
                                        setCategoryFilter={setCategoryFilter}
                                    />
                                );
                            })}

                        <h4 className="filterName">{categoryTypes.double[lang]}</h4>
                        {double
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((category, index) => {
                                return (
                                    <CategorySingleFilter
                                        key={`cat-single-${category.id}-${index}`}
                                        category={category}
                                        index={index}
                                        categoryFilter={categoryFilter}
                                        setCategoryFilter={setCategoryFilter}
                                    />
                                );
                            })}

                        <h4 className="filterName">{categoryTypes.flexliner[lang]}</h4>
                        {flexliner
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((category, index) => {
                                return (
                                    <CategorySingleFilter
                                        key={`cat-single-${category.id}-${index}`}
                                        category={category}
                                        index={index}
                                        categoryFilter={categoryFilter}
                                        setCategoryFilter={setCategoryFilter}
                                    />
                                );
                            })}
                    </>
                ) : (
                    categories
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((category, index) => {
                            return (
                                <CategorySingleFilter
                                    key={`cat-single-${category.id}-${index}`}
                                    category={category}
                                    index={index}
                                    categoryFilter={categoryFilter}
                                    setCategoryFilter={setCategoryFilter}
                                />
                            );
                        })
                )}
            </div>
        </div>
    );
}
